import { languageConstant } from "../constants/indicafix.constants";
import { THEME_ENUM } from "../constants/theme.constant";

export const themeConfig = {
  themeColor: "teal",
  direction: THEME_ENUM.DIR_LTR,
  mode: THEME_ENUM.MODE_LIGHT,
  locale: languageConstant.ENGLISH,
  primaryColorLevel: 600,
  cardBordered: true,
  panelExpand: false,
  controlSize: "md",
  navMode: THEME_ENUM.NAV_MODE_LIGHT,
  layout: {
    type: THEME_ENUM.LAYOUT_TYPE_LOADING,
    sideNavCollapse: true,
  },
};
